export default {
  SET_SALES_CONSULTANTS: (state, data) => {
    state.salesConsultants = data;
  },
  SET_SALES_CONSULTANT: (state, data) => {
    state.salesConsultant = data;
  },
};
